import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./baseQuery";
export interface PaymentOptions {
  available_currencies: {
    [key: string]: string;
  };
  available_payments: {
    [key: string]: string;
  };
  currencies: {
    [key: string]: {
      [key: string]: string;
    };
  };
  payments: {
    [key: string]: {
      [key: string]: string;
    };
  };
}
export const internalService = createApi({
  reducerPath: "internalService",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getInfoSmartRouting: builder.query<PaymentOptions, void>({
      query: () => ({
        url: `/info/smartRouting`,
        method: "GET",
      }),
      transformResponse: (rawData: any) => {
        return rawData.success && (rawData.data as PaymentOptions);
      },
    }),
    saveSmartRouting: builder.mutation<any, any>({
      query: ({ merchantId, ...rest }) => ({
        url: `/merchant/${merchantId}/smartRouting`,
        body: { ...rest },
        method: "POST",
      }),
    }),
  }),
});

export const { useGetInfoSmartRoutingQuery, useSaveSmartRoutingMutation } = internalService;
